import { JSX } from 'react'

import { DisconnectButton } from '~/components/DisconnectButton'
import { Button, Tooltip } from '~/components/component-library'
import { PrivyWalletBridge } from '~/components/smart-accounts/usePrivyWalletBridge'
import { useApproveEmailSigner } from '~/hooks/smart-account-actions/useApproveEmailSigner'
import { BackendTransaction } from '~/types'
import { captureException } from '~/utils/errors'

export const ApproveTransactionButton = ({
  transaction,
  onClose,
  hasAccessOverride,
  suffix,
  shortcut = false,
  onConfirmation,
  onSubmitError,
  isDisabledOverride,
  disabledReasonOverride,
  privyBridge,
}: {
  transaction: BackendTransaction
  onClose?: () => void
  hasAccessOverride?: boolean
  suffix?: JSX.Element
  shortcut?: boolean
  onConfirmation?: () => void
  onSubmitError?: (e: unknown) => void
  isDisabledOverride?: boolean
  disabledReasonOverride?: string | JSX.Element
  privyBridge: PrivyWalletBridge
}) => {
  const {
    onApprove,
    triggerShortcut,
    buttonText,
    disabledReason,
    isLoading,
    isDisabled,
    isProcessing,
    showDisconnectButton,
    showPrivyDisconnect,
    disconnectPrivyAndEOAs,
    actionEventName,
    actionEventProperties,
    isApprovalActionLoading,
  } = useApproveEmailSigner({
    transaction,
    onClose,
    hasAccessOverride,
    onConfirmation,
    onSubmitError,
    isDisabledOverride,
    disabledReasonOverride,
    privyBridge,
  })

  return (
    <div className="flex flex-row justify-end space-x-2">
      {showPrivyDisconnect && (
        <Tooltip
          content={
            <div>
              You are currently connected
              {privyBridge.privyEmail ? ` as ${privyBridge.privyEmail}` : ''}
            </div>
          }
        >
          <Button
            variant="secondary"
            isDisabled={isApprovalActionLoading}
            onClick={() => {
              void disconnectPrivyAndEOAs().catch((e) => captureException(e))
            }}
          >
            Disconnect
          </Button>
        </Tooltip>
      )}
      {showDisconnectButton && <DisconnectButton />}
      <Button
        shortcut={
          shortcut
            ? {
                key: 'meta+enter',
                callback: () => {
                  if (isDisabled) return
                  triggerShortcut()
                },
              }
            : undefined
        }
        onClick={onApprove}
        eventName={actionEventName}
        eventProperties={actionEventProperties}
        isDisabled={isDisabled}
        disabledReason={disabledReason}
        alignLeft={showDisconnectButton}
        isLoading={isLoading}
        suffix={suffix}
      >
        {buttonText}
      </Button>
    </div>
  )
}
